function strToChars(str) {
  let chars = [];
  for (var i = 0; i < str.length; i++) {
    chars[i] = [str.substr(i, 1), isCHS(str, i)];
  }
  return chars;
}

function isCHS(str, i) {
  if (str.charCodeAt(i) > 255 || str.charCodeAt(i) < 0) return true;
  else return false;
}

function substringChs(strOrigin, start, end) {
  let len = 0;
  let str = "";
  let chars = strToChars(strOrigin);
  for (let i = 0; i < strOrigin.length; i++) {
    if (chars[i][1]) len += 2;
    else len++;
    if (end < len) return str;
    else if (start < len) str += chars[i][0];
  }
  return str;
}

function conStr2Obj(res) {
  let obj = {};
  if (!res) {
    return obj;
  }
  let alllines = res.split("\n");
  for (let i = 0; i < alllines.length; i++) {
    let arr = alllines[i].split(":");
    if (arr === null || arr.length !== 2) continue;
    let keys = arr[0].trim().split(".");
    if (keys === null || keys.length <= 0) continue;

    let objTmp = obj;
    for (let j = 0; j < keys.length; j++) {
      if (j === keys.length - 1) {
        if (!objTmp[keys[j]]) {
          objTmp[keys[j]] = arr[1].trim();
        }
      } else {
        if (!objTmp[keys[j]]) {
          objTmp[keys[j]] = {};
        }
        objTmp = objTmp[keys[j]];
      }
      // console.log(objTmp)
    }
  }

  return obj;
}
function conMask(numof1) {
  if (!numof1) {
    return "";
  }
  numof1 = parseInt(numof1);
  let str = "255.255.255.0";
  let num = parseInt(numof1 / 8);
  let remainder = numof1 - num * 8;
  if (num < 1 || num > 4) {
    return str;
  } else {
    str = "";
    for (let i = 0; i < 4; i++) {
      let val = 255;
      if (i >= num) {
        if (remainder <= 8) {
          val = (255 << (8 - remainder)) & 0xff;
          remainder = 0;
        } else {
          remainder -= 8;
        }
      }
      str += `${val}${i === 3 ? "" : "."}`;
    }
  }
  return str;
}
function con2Ipv4Obj(res, details) {
  let obj = conStr2Obj(res);

  if (!obj) return null;

  let tmp = obj.IP4;
  if (!tmp) return null;
  let ipv4More = obj.ipv4;
  let ipv4 = {
    method: "auto",
    dns: "",
    address: "",
    mask: "",
    gateway: ""
  };
  let valTmp = tmp["ADDRESS[1]"];
  let addresses = valTmp ? valTmp.split("/") : [];
  valTmp = tmp["DNS[1]"];
  ipv4.dns = valTmp ? (valTmp.indexOf(".") >= 0 ? valTmp : "") : "";
  ipv4.gateway = tmp.GATEWAY || "";
  ipv4.address = addresses[0] || "";
  ipv4.mask = conMask(addresses[1]);

  ipv4.method = ipv4More.method || "auto";

  ipv4.dns = ipv4.dns.replace("--", "");
  ipv4.gateway = ipv4.gateway.replace("--", "");
  ipv4.address = ipv4.address.replace("--", "");
  ipv4.mask = ipv4.mask.replace("--", "");
  return ipv4;
}
function con2Ipv4ObjOld(res) {
  let obj = conStr2Obj(res);
  if (!obj) return null;

  let tmp = obj.ipv4;
  if (!tmp) return null;

  let ipv4 = {
    method: "auto",
    dns: "",
    address: "",
    mask: "",
    gateway: ""
  };
  let addresses = tmp.addresses ? tmp.addresses.split("/") : [];
  ipv4.method = tmp.method || "auto";
  ipv4.dns = tmp.dns ? (tmp.dns.indexOf(".") >= 0 ? tmp.dns : "") : "";
  ipv4.gateway = tmp.gateway || "";
  ipv4.address = addresses[0] || "";
  ipv4.mask = conMask(addresses[1]);
  ipv4.dns = ipv4.dns.replace("--", "");
  ipv4.gateway = ipv4.gateway.replace("--", "");
  ipv4.address = ipv4.address.replace("--", "");
  ipv4.mask = ipv4.mask.replace("--", "");
  return ipv4;
}
function getMaskNumber(maskstr) {
  let masknum = 24;
  if (!maskstr) {
    return masknum;
  }
  let arr = maskstr.split(".");
  if (!arr || arr.length !== 4) {
    return masknum;
  }

  let has0 = false;
  let numTmp = 0;
  for (let i = 0; i < arr.length; i++) {
    let num = parseInt(arr[i]);
    let binary = num.toString(2);
    for (let j = 0; j < binary.length; j++) {
      if (binary[j] === "1") {
        if (has0) return masknum;
        else numTmp++;
      } else {
        has0 = true;
      }
    }
  }
  return numTmp;
}
function getConWlanInfo(wlanlist) {
  for (let i = 0; i < wlanlist.length; i++) {
    if (wlanlist[i]["device"].length > 0 && wlanlist[i]["device"] !== "--") {
      return wlanlist[i];
    }
    // if (wlanlist[i]['in-use'] === '*') {
    //   return wlanlist[i]
    // }
  }
  return null;
}

function str2wifiArr(str) {
  let list = [];
  let allLines = str.split("\n");
  let firstLine = allLines[0];
  let keyInfo = [];
  let keyTmp = "";
  let indexTmp = 0;
  // 通过标题行获取key和对应的索引
  for (let i = 0; i < firstLine.length; i++) {
    if (firstLine[i] === " ") {
      if (indexTmp >= 0) {
        keyInfo.push({ key: keyTmp, startId: indexTmp });
        keyTmp = "";
        indexTmp = -1;
      }
    } else {
      if (indexTmp < 0) indexTmp = i;
      keyTmp += firstLine[i];
    }
  }

  keyInfo.forEach((item, i) => {
    if (i >= keyInfo.length - 1) {
      item.endId = firstLine.length - 1;
    } else {
      item.endId = keyInfo[i + 1].startId;
    }
  });
  // console.log(keyInfo)

  allLines.forEach((line, id) => {
    if (id === 0 || line.length <= 0) return;
    let obj = {};
    keyInfo.forEach((item) => {
      obj[item.key.toLowerCase()] = substringChs(line, item.startId, item.endId).trim();
    });
    list.push(obj);
  });
  // console.log(list)
  return list;
}

export default {
  substringChs,
  str2wifiArr,
  getConWlanInfo,
  conStr2Obj,
  con2Ipv4Obj,
  getMaskNumber
};



// WEBPACK FOOTER //
// ./src/mainInterface/js/wifi/NmcliHelper.js